var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.577 0.756057C14.3381 0.518057 13.982 0.436682 13.6643 0.551307L1.41433 4.92631C1.08446 5.04356 0.856082 5.34718 0.835082 5.69631C0.814082 6.04631 1.00308 6.37443 1.31721 6.53193L5.32996 8.53743L10.4583 4.87468L6.79471 10.0039L8.80021 14.0167C8.94983 14.3133 9.25346 14.4997 9.58333 14.4997C9.60171 14.4997 9.61921 14.4988 9.63671 14.4979C9.98671 14.4769 10.2903 14.2494 10.4085 13.9187L14.7835 1.66868C14.8963 1.35106 14.8158 0.994932 14.577 0.756057Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconWhite);
export default __webpack_public_path__ + "static/media/send-icon-white.59dd6aae8399cbd3b8a4c36f2da438d5.svg";
export { ForwardRef as ReactComponent };